import React from 'react';
import ImageService from '../../services/image.service';
import {
  Col,
  Row,
  Button,
} from 'reactstrap';

const SelectImages = ({ onImageClick, data, page, goToPage, count }) => {
    return (
        <div className="d-flex align-items-">
            <Button disabled={!page} onClick={() => goToPage(page - 1)}>
                prev
            </Button>
            <Row className="px-5" style={{width: '100%'}}>
            {data && data.length ? data.map((image) => {
                return <Col key={image.image}>
                <div onClick={() => onImageClick(image)}>
                    <img width="100%" src={image && ImageService.getImage(image.image)} style={{objectFit: 'cover'}} title={`alt: ${image.alt}, title: ${image.title}`}/>
                </div>
                </Col>
            }
            ): <div className="col-12 text-center">No images</div>}            
            </Row>
            <Button disabled={(page + 1) * 10 >= count} onClick={() => goToPage(page + 1)}>
                next
            </Button>
        </div>
    );
};

export default SelectImages;


// WEBPACK FOOTER //
// ./src/components/selectImages/SelectImages.jsx